import React from 'react';
import Dialog from '../../../Components/Dialog';

import './index.scss'

const ConfirmDialog = (props) => {
  let { title, content, fn, visible, setVisible, closeCb, closeText, confirmText } = props

  return (
    <Dialog title={title||"温馨提示"} visible={visible} setVisible={setVisible} closeCb={closeCb}>
      <div className="ConfirmDialog">
        <header className="content">
          {content}
        </header>
        <footer className="btn">
          <div className="left" onClick={()=>{setVisible(false);closeCb&&closeCb()}}>{closeText || "取消"}</div>
          <div className="right" onClick={()=>{
            fn && fn();
          }}>{confirmText || "确认"}</div>
        </footer>
      </div>
    </Dialog>
  );
}

export default ConfirmDialog;
